import React, { ReactNode } from 'react';

import { Button } from '@components/Button';
import { makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    padding: '0 8px',
    width: '100%',
    ...common.flexColumn,
  },
  title: {
    width: '100%',
    ...common.flexInline,
    alignItems: 'center',
    height: 64,
  },
  titleTextColumn: {
    ...common.flexInline,
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: theme.palette.grey[800],
    width: '50%',
  },
  titleTextDefault: {
    ...common.normalText,
    ...common.fontWeight500,
  },
  titleTextLarge: {
    ...common.normalText,
    fontSize: '2rem',
    ...common.fontWeight500,
    lineHeight: 'initial',
  },
  titleButtonsColumn: {
    ...common.flexInline,
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '50%',
  },
  button: {
    height: 40,
    borderRadius: 20,
    padding: '5px 16px',
    marginLeft: 10,
  },
  divider: {
    backgroundColor: theme.palette.grey[200],
    height: 1,
    width: '100%',
  },
}));

export interface FormTitleAction {
  title: string;
  action?: () => void;
}

export type TitleSize = 'default' | 'large';

export interface FormTitleProps {
  title: string;
  presetActionNode?: ReactNode;
  actions?: FormTitleAction[];
  titleSize?: TitleSize;
  lineDivider?: boolean;
}

export const FormTitle: React.FC<FormTitleProps> = (props) => {
  const classes = useStyles();

  const { title, presetActionNode, actions, titleSize = 'default', lineDivider = true } = props;

  return (
    <div className={clsx(classes.container)}>
      <div className={clsx(classes.title)}>
        <div
          role="heading"
          className={clsx(
            classes.titleTextColumn,
            titleSize === 'large' ? classes.titleTextLarge : classes.titleTextDefault,
          )}
        >
          {title}
        </div>
        <div className={clsx(classes.titleButtonsColumn)}>
          {presetActionNode}
          {actions?.map((item, index) => (
            <Button
              key={index}
              color="primary"
              shape="round"
              text={item.title}
              onClick={item.action}
            />
          ))}
        </div>
      </div>
      {lineDivider && <div className={clsx(classes.divider)} />}
    </div>
  );
};
